import React, {Component} from "react";
import {BsX} from 'react-icons/bs';

import {compose} from "redux";
import {withTranslation} from "react-i18next";
import ExistingPatient from "./ExistingPatient";


import {history} from "../../utils/history";
import SvGraphics from "../../assets/SvGraphics";
import utils from "../../utils/utils";
import {makeError} from "../modals/ErrorModal";
import doctorApi from "../../services/ApiServices/doctorApi";


class AddPatientComposed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isNewPatientOpen:false,
            isExistingPatientOpen:false
        };
    }

    async closeSideBar(){
        document.body.style.overflow = "auto"
        this.props.closeSideBar(false)
        this.setState({entry:null})
    }

    async openNewPatient(){

        let allData = await doctorApi.getAllData()
        if(allData){
            allData=allData.data
        }

        history.push({
            pathname: `/dashboard/PatientOnboard`,
            state: {
                allData,
                from: {
                    fromPath: `/dashboard`,
                }
            },
        })
    }



    async openExistingPatient(){
        document.body.style.overflow = "auto"
        document.body.style.overflow = "hidden"
        this.setState({isExistingPatientOpen:true})

        /*    history.push({
                pathname: `/dashboard/ExistingPatient`,
                state: {
                    from: {
                        fromPath: `/dashboard`,
                    }
                },
            })*/
    }

    render() {
        let width = this.props.isSideBarOpen ? "600px" : "0px"
        let container_width = this.props.isSideBarOpen ? "100%" : "0px"
        let {t} = this.props
        let {isExistingPatientOpen} = this.state


        return (
            <div className={"sidenav-complete2"} style={{width:container_width, height:"100%"}} >
                <div className={"sidenav-complete2"} style={{width:container_width, height:"100%"}} onClick={this.closeSideBar.bind(this)}/>
                <div className={"sidenav"} style={{width:width, height:"100%"}}>
                    <BsX onClick={this.closeSideBar.bind(this)} size={35} style={{
                        float: 'left',
                        top: '10px',
                        left: '10px',
                        position: 'absolute',
                    }}/>
                    <div className={'filterFont'}> {t('doctor.addPatient.addPatient')}</div>
                    <div className={'filterBorders'}>
                        <div className={'addPatientBox'} onClick={this.openNewPatient.bind(this)} >
                            <SvGraphics className={"add-edit-patient-icon"} svgname={'new-patient-icon'}/>

                            <div className={'addPatientBoxTitle'}>  {t('doctor.add_new_patients')}  </div>
                            <div className={'addPatientBoxContent'}>  {t('doctor.addPatient.new_content')}  </div>
                        </div>
                        <div className={'addPatientBox'} onClick={this.openExistingPatient.bind(this)} >
                            <SvGraphics className={"add-edit-patient-icon"} svgname={'existing-patient-icon'}/>

                            <div className={'addPatientBoxTitle'}>  {t('doctor.addPatient.existing')}   </div>
                            <div className={'addPatientBoxContent'}>  {t('doctor.addPatient.existing_content')}  </div>
                        </div>
                    </div>
                </div>
                {isExistingPatientOpen && <ExistingPatient
                    title={'Edit Admin'}
                    isExistingPatientOpen={isExistingPatientOpen}
                    closeSideBar={() => this.setState({isExistingPatientOpen: false})}/>}
            </div>
        );
    }
}


const AddPatient = compose(
    withTranslation(),
    /*connect(
        mapStateToProps,
        mapDispatchToProps
    )*/
)(AddPatientComposed);

export default AddPatient;
